export const ACTIVE_USERS_GRAPH = 'active-users';

export const GA4_AVERAGE_SESSION_GRAPH = 'average-session-duration';

export const ACTIVE_USERS_CONFIG = {
  graphName: ACTIVE_USERS_GRAPH,
  header: {
    title: { key: 'ANALYTICS.GA4METRICS.ACTIVE_USERS.TITLE' },
    subtitle: { key: 'ANALYTICS.GA4METRICS.ACTIVE_USERS.SUBTITLE' },
  },
};
export const GA4_AVERAGE_SESSION_CONFIG = {
  graphName: GA4_AVERAGE_SESSION_GRAPH,
  header: {
    title: { key: 'ANALYTICS.GA4METRICS.AVERAGE_SESSION.TITLE' },
    subtitle: { key: 'ANALYTICS.GA4METRICS.AVERAGE_SESSION.SUBTITLE' },
  },
};
